import { Minus, Plus } from 'lucide-react';
import { cn } from '@/lib/utils';

export type StepperProps = {
  value: number;
  onChange: (next: number) => void;
  min?: number;
  max?: number;
  unit?: string;
};

export function Stepper({ value, onChange, min = 0, max = 99, unit }: StepperProps) {
  const decrement = () => onChange(Math.max(min, value - 1));
  const increment = () => onChange(Math.min(max, value + 1));

  const buttonCls =
    'flex h-12 w-12 items-center justify-center rounded-full border-2 border-border text-foreground transition-all enabled:hover:border-primary enabled:hover:bg-primary/5 disabled:opacity-40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2';

  return (
    <div className="inline-flex items-center gap-4">
      <button
        type="button"
        aria-label="Diminuir"
        className={cn(buttonCls)}
        onClick={decrement}
        disabled={value <= min}
      >
        <Minus className="h-5 w-5" />
      </button>
      <div className="min-w-[3.5rem] text-center">
        <div className="text-2xl font-bold tabular-nums text-foreground">{value}</div>
        {unit && <div className="text-xs text-muted-foreground">{unit}</div>}
      </div>
      <button
        type="button"
        aria-label="Aumentar"
        className={cn(buttonCls)}
        onClick={increment}
        disabled={value >= max}
      >
        <Plus className="h-5 w-5" />
      </button>
    </div>
  );
}
